import { FormsModel } from '../models/StoreDetailModel'
import { FORM_SCHEDULE_STATUS, FORM_TYPES } from '../constants/constants.stores'

/**
 * Determina si un formulario está disponible para ser relevado.
 */
export const isFormAvailable = (form: FormsModel): boolean => {
    const status = form.status
    const isRepetible = form.repeat === true || form.can_repeat === true
    const isFormRedirect = form.type_form?.type === FORM_TYPES.FORM_REDIRECT

    // FORM_REDIRECT ya completado no está disponible
    if (
        isFormRedirect &&
        (status === FORM_SCHEDULE_STATUS.COMPLETED ||
            status === FORM_SCHEDULE_STATUS.PENDING_CONNECTION)
    ) {
        return false
    }

    // Forms completados o pendientes de conexión que no son repetibles no están disponibles
    if (
        (status === FORM_SCHEDULE_STATUS.COMPLETED ||
            status === FORM_SCHEDULE_STATUS.PENDING_CONNECTION) &&
        !isRepetible
    ) {
        return false
    }

    return true
}

/**
 * Busca el índice del siguiente formulario disponible (wrap-around).
 * Retorna -1 si no hay ninguno disponible.
 */
export const getNextAvailableFormIndex = (
    forms: FormsModel[],
    currentFormId: string | undefined,
): number => {
    if (!forms || forms.length === 0 || !currentFormId) return -1

    const currentIndex = forms.findIndex((f) => f._id === currentFormId)
    if (currentIndex === -1) return -1

    const total = forms.length

    // Buscar desde currentIndex + 1 hasta el final, luego desde 0 hasta currentIndex
    for (let i = 1; i < total; i++) {
        const candidateIndex = (currentIndex + i) % total
        if (isFormAvailable(forms[candidateIndex])) {
            return candidateIndex
        }
    }

    return -1
}
